module.exports = "<h2 class=\"dash-header\" hide-xs>\n  <span>Manage Jobs</span>\n</h2>\n\n<span flex></span>\n"